(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-tabs-detalles"] && !Shopify.designMode) return;
  try {
    
  class PdpTabs extends HTMLElement {
    connectedCallback() {
      this.buttons = this.querySelectorAll('[data-pdp-tab]');
      this.panels = this.querySelectorAll('[data-pdp-tab-panel]');
      this.buttons.forEach(btn => {
        btn.addEventListener('click', () => this.activate(btn.dataset.pdpTab));
      });
    }

    activate(index) {
      this.buttons.forEach(btn => {
        const active = btn.dataset.pdpTab === index;
        btn.classList.toggle('is-active', active);
        btn.setAttribute('aria-selected', String(active));
      });
      this.panels.forEach(panel => {
        const active = panel.dataset.pdpTabPanel === index;
        panel.classList.toggle('is-active', active);
        panel.hidden = !active;
      });
    }
  }

  if (!customElements.get('pdp-tabs')) {
    customElements.define('pdp-tabs', PdpTabs);
  }

  } catch(e) { console.error(e); }
})();
})();
